const initialState = {
    sellerId: 0,
    orgId: 0,
}

export function setSellerAndOrgId(state = initialState, action) {
    switch (action.type) {
        case 'SET_ID_TO_STATE':
       
            return {
                sellerId: action.data.sellerId,
                orgId: action.data.orgId
            }
            break;
        default:
            return state
            break;
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/setID.reducer.js